import LocationLayerVersion from '@client-shared/models/location-layer-version.model'

export default class LocationLayer {
  constructor ({ _id, projectId, order, title, createdByUserId, tilesDownloadUrl, isActive, locationRestrictions, created, modified, activeVersionId, versions }) {
    this._id = _id
    this.projectId = projectId
    this.order = order
    this.title = title
    this.createdByUserId = createdByUserId
    this.tilesDownloadUrl = tilesDownloadUrl
    this.isActive = isActive
    this.created = created
    this.modified = modified
    this.locationRestrictions = {
      location1: locationRestrictions.location1,
      location2: locationRestrictions.location2,
      location3: locationRestrictions.location3,
      location4: locationRestrictions.location4,
    }
    this.activeVersionId = activeVersionId
    // Persisted storage written by pre-versioning app builds has no versions field
    this.versions = (versions || []).map(version => new LocationLayerVersion(version))

    this.computed = {
      activeVersion: this.versions.find(version => version._id === this.activeVersionId) || null,
    }
  }

  canDiscardVersion (version) {
    if (!version) {
      return false
    }

    if (version._id === this.activeVersionId) {
      return false
    }

    return !version.isUsed
  }
}
